import React from 'react';
import { createRoot } from 'react-dom/client';
import AdminModalHandler from './components/AdminModalHandler';

let root = null;

function RenderAdminModalHandler(props = {}, ele) {
  if (ele) {
    if (root) {
      root.unmount();
    }
    root = createRoot(ele);
    root.render(<AdminModalHandler {...props} />);
  }
}

window.RenderAdminModalHandler = RenderAdminModalHandler;
